export default __webpack_public_path__ + "static/media/PSLxText-Regular.ade0d118.ttf";